import styled from "styled-components";

export const Text = styled.p`
  all: unset;
  color: ${({ theme }) => theme.authModal.primaryText};
  font: 400 0.875rem/1.219rem "Inter";
  margin: 0;
`;

interface IInvalidInputContainerProps {
  showMessage: boolean;
}
export const InvalidInputContainer = styled.div<IInvalidInputContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;

  text-align: center;

  &,
  ${Text} {
    padding: ${({ showMessage }) => (showMessage ? "0.125rem  0" : "0")};
    opacity: ${({ showMessage }) => (showMessage ? "1" : "0")};
    height: ${({ showMessage }) => (showMessage ? "auto" : "0px")};
  }
`;
